<nav class="navigation">
    <ul class="navigation__list">
        <ng-container *ngFor="let navItem of navigationItems; let index = index">
            <li class="navigation__list__item">
                <a [routerLink]="navItem.route">{{ navItem.title }}</a>
            </li>
            <img 
                *ngIf="index !== navigationItems.length - 1"
                src="./assets/images/dealer-dashboard/chevron-right.svg" 
                alt="Arrow Right">
        </ng-container>
    </ul>
</nav>